if (!customElements.get('buy-now-button')) {
  class BuyNowButton extends HTMLElement {
    _marks = {
      loading: "loading"
    };

    _shopify_features_script = document.querySelector("script[id='shopify-features']");
    _shopify_features_json = JSON.parse(this._shopify_features_script.innerHTML);
    _checkout_headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
      'authorization': 'Basic ' + btoa(this._shopify_features_json.accessToken)
    };

    get _variantId() { return this.getAttribute("data-variant-id") }
    get _quantity() { return this.getAttribute("data-quantity") ?? 1 }

    constructor() {
      super();
    }

    connectedCallback() {
      this.elements = {
        loadingSpinner: this.querySelector(".loading__spinner"),
      };
      this.addEventListener('click', () => {
        this.startLoading();
        this.checkout().finally(() => {
          this.finishLoading();
          console.log("end");
        });
      });
    }

    async checkout() {
      const variantIds = this._variantId.split(',');
      let lineItems = variantIds.map(variantId => ({
        "variant_id": variantId,
        "quantity": this._quantity
      }));

      let checkout_json = {
        "checkout": {
          "line_items": lineItems,
          "secret": true,
          "wallet_name": "Checkout",
          "is_upstream_button": false,
          "page_type": "product",
          "has_selling_plans": false,
          "presentment_currency": window.shop_currency,
          "country": window.shop_locale_upcase
        }
      };

      let data = JSON.stringify(checkout_json);

      return fetch("/wallets/checkouts.json", {
        method: 'POST',
        headers: this._checkout_headers,
        body: data
      }).then((response) => {
        if (response.ok) {
          return response.text();
        } else {
          this._buyNowProduct(this._variantId, this._quantity);
        }
      }).then((strj) => {
        if (strj) {
          let checkout_json = JSON.parse(strj);
          location.href = checkout_json.checkout.web_url;
        }
      }).catch((err) => {
        console.error(err);
      });
    }

    startLoading() {
      this.setAttribute("aria-disabled", true);
      this.classList.add(this._marks.loading);
      this.querySelector(".loading__spinner")?.classList.remove("hidden");
    }

    finishLoading() {
      this.removeAttribute("aria-disabled");
      this.classList.remove(this._marks.loading);
      this.querySelector(".loading__spinner")?.classList.add("hidden");
    }

    _buyNowProduct(id, qty) {
      if(id && qty){
        console.log(`/cart/${id}:${qty}`);
        window.location.href = `/cart/${id}:${qty}`;
      }
      
      // const itemsToAdd = [{
      //   id: id,
      //   quantity: qty,
      // }];

      // $.ajax({
      //   type: "POST",
      //   url: "/cart/add.js",
      //   data: {
      //     items: itemsToAdd,
      //   },
      //   dataType: "json",
      //   success: function () {
      //     window.location.href = "/checkout";
      //   },
      //   error: function () {
      //     console.log("加购失败，请重试。");
      //   },
      // });
    }
  }

  customElements.define('buy-now-button', BuyNowButton);
}
 